import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import Card from './card';
import OpenIndicator from './openIndicator';

export const Outlet = data => {
  const { businessID, name, openingHours, shortDescription, isOpen } = data;
  const route = `/${businessID}`;

  const handleClick = () => {
    if (data) {
      window.location.href = `/itpi/lighthouse/outlets/${
        data.businessID
      }}`;
    } else {
      const id = route.substring(1, route.length);
      window.location.href = `/itpi/lighthouse/outlets/${id}}`;
    }
  };

  return (
    // <Link to={{ pathname: route, data }}>
    <div style={{ cursor: 'pointer' }} onClick={handleClick}>
      <Card
        styles={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 15,
          marginBottom: 20,
          marginRight: 15,
          maxWidth: '400px',
          borderRadius: '5%'
        }}
      >
        <div style={{}}>
          <h2>
            {name}
          </h2>
          <p style={{ fontSize: '15px', color: '#626262' }}>
            {shortDescription}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'baseline'
          }}
        >
          <div style={{ maxWidth: '50%' }}>
            <OpenIndicator openingHours={openingHours} isOpen={isOpen} />
          </div>
        </div>
      </Card>
    </div>
    // </Link>
  );
};

export default withRouter(Outlet);
